import ContentOverlay from "../components/content_overlay";
import {Link} from "react-router-dom";
import "./announcements.css";

function AnnouncementsPage(){
    return (
        <ContentOverlay
        heading={ <h3 style={{textAlign:"center"}}>Announcements</h3>  }
        text_content={<div className="container"><p class="western"  ><u><strong>Global Level</strong></u></p>
            <ol>
            <li>
            <p  ><strong>1st IIR International Conference on Refrigeration Adapting to Rising Temperatures</strong></p>
            
            <p  >Date: 10<sup>th</sup>-13<sup>th</sup> Aug 2025</p>
            <p  >Place: University of Manchester, UK</p>
            <p  ><u><a href="https://ior.org.uk/events/adaptation2025">https://ior.org.uk/events/adaptation2025</a></u></p></li></ol>
            
            
            <ol start="2">
            <li>
            <p ><strong>5thGlobal Congress on Climate Change(GCCC-2025)</strong></p>
            
            <p >Date:29<sup>th</sup> -30<sup>th</sup> September 2025</p>
            <p >Place: Berlin, Germany</p>
            <p ><u><a href="https://global-climatechange.com/">https://global-climatechange.com/</a></u></p></li></ol>
            <p class="western"></p>
            <ol start="3">
            <li>
            <p ><strong>5th International Conference on Climate Change &amp; Sustainability</strong></p>
            
            <p >Date: 10<sup>th</sup> -11<sup>th</sup> November 2025</p>
            <p >Place: Dubai, UAE</p>
            <p ><u><a href="https://climatechange.averconferences.com/">https://climatechange.averconferences.com/</a></u></p></li></ol>
            <p class="western"></p>
            <ol start="4">
            <li>
            <p ><strong>International Conference on Global Warming, Climate Change and Pollution Control (GWCCPC-25)</strong></p>
            
            <p >Date: 25<sup>th</sup>-26<sup>th</sup> April 2025</p>
            <p >Place: Bristol, UK</p>
            <p ><u><a href="https://iser.org.in/conf/index.php?id=2815840">https://iser.org.in/conf/index.php?id=2815840</a></u></p></li></ol>
            <p ></p>
            <p ></p>
            <ol start="5">
            <li>
            <p ><strong>Climate Weeks 2025</strong></p>
            
            <p >Date: 19<sup>th</sup>-23<sup>rd</sup> May 2025</p>
            <p >Place:Panama City, Africa</p>
            <p ><u><a href="https://unfccc.int/topics/climate-weeks">https://unfccc.int/topics/climate-weeks</a></u></p></li></ol>
            <p ></p>
            <p class="western" ></p>
            <ol start="6">
            <li>
            <p ><strong>2025 United Nations Climate Change Conference (COP30)</strong></p>
            
            <p >Date: 10<sup>th</sup>-21<sup>st</sup> November 2025</p>
            <p >Place:Bel&eacute;m, Brazil</p>
            <p ><u><a href="https://unfccc.int/cop30">https://unfccc.int/cop30</a></u></p></li></ol>
            <p class="western" ></p>
            <ol start="7">
            <li>
            <p ><strong>IUCN World Conservation Congress</strong></p>
            
            <p >Date: 9<sup>th</sup>-15<sup>th</sup> October 2025</p>
            <p >Place:Abu Dhabi, U.A.E.</p>
            <p ><u><a href="https://iucncongress2025.org/">https://iucncongress2025.org/</a></u></p></li></ol>
            <p class="western" ></p>
            <ol start="8">
            <li>
            <p ><strong>2nd Global Summit on Climate Change &amp; Environmental Sustainability</strong></p>
            
            <p >Date: 18<sup>th</sup>-19<sup>th</sup> September 2025</p>
            <p >Place: Sonesta Los Angeles Airport LAX, LA, USA</p>
            <p ><u><a href="https://climatechangeconferences.org/">https://climatechangeconferences.org/</a></u></p></li></ol>
            <p class="western" ></p>
            <ol start="9">
            <li>
            <p ><strong>6</strong><strong><sup>th</sup></strong><strong> World </strong><strong>conference on </strong><strong>Climate </strong><strong>change and Global Warming </strong></p>
            
            <p >Date: 21<sup>st</sup>-23<sup>rd</sup> September 2025</p>
            <p >Place: Copenhagen, Denmark</p>
            <p ><u><a href="https://www.ccgconf.org/">https://www.ccgconf.org/</a></u></p></li></ol>
            <p ></p>
            <p ></p>
            <ol start="10">
            <li>
            <p ><strong>UNFCCC Climate Meetings (SB 62 &ndash; Bonn)</strong></p>
            
            <p >Date: 16<sup>th</sup>-26<sup>th</sup> June 2025</p>
            <p >Place: Bonn, Germany</p>
            <p ><u><a href="https://unfccc.int/">https://unfccc.int/</a></u></p></li></ol>
            <p class="western" ></p>
            <ol start="11">
            <li>
            <p ><strong>US Climate Action Summit</strong></p>
            
            <p >Date:21<sup>st</sup>-25<sup>th</sup> April 2025</p>
            <p >Place: Washington DC</p>
            <p ><u><a href="https://www.theclimategroup.org/us-climate-action-summit-2025">https://www.theclimategroup.org/us-climate-action-summit-2025</a></u></p></li></ol>
            <p class="western" ></p>
            <ol start="12">
            <li>
            <p ><strong>Climate Group Asia </strong><strong>Action </strong><strong>Summit</strong></p>
            
            <p >Date: 8<sup>th</sup> June 2025</p>
            <p >Place: Singapore</p>
            <p ><u><a href="https://www.theclimategroup.org/climate-group-asia-action-summit">https://www.theclimategroup.org/climate-group-asia-action-summit</a></u></p></li></ol>
            <p class="western" ></p>
            <ol start="13">
            <li>
            <p ><strong>Climate Week NYC </strong></p>
            
            <p >Date: 21<sup>st </sup>September 2025</p>
            <p >Place: New York</p>
            <p ><u><a href="https://www.climateweeknyc.org/">https://www.climateweeknyc.org/</a></u></p></li></ol>
            <p class="western" ></p>
            <ol start="14">
            <li>
            <p ><strong>2025 United Nations Climate and SDGs Conference</strong></p>
            
            <p >Date: 27<sup>th</sup>-28<sup>th</sup> May 2025</p>
            <p >Place: UN City in Copenhagen, Denmark</p>
            <p ><u><a href="https://www.un.org/en/climate-sdgs-conference-2025">https://www.un.org/en/climate-sdgs-conference-2025</a></u></p></li></ol>
            <p class="western" ></p>
            <ol start="15">
            <li>
            <p ><strong>Global Conference on Climate and Health</strong></p>
            
            <p >Date: 29<sup>th</sup>-31<sup>st</sup> July 2025</p>
            <p >Place: Brasilia, Brazil</p>
            <p ><u><a href="https://www.who.int/news-room/events/detail/2025/07/29/default-calendar/2025-global-conference-on-climate-and-health">https://www.who.int/news-room/events/detail/2025/07/29/default-calendar/2025-global-conference-on-climate-and-health</a></u></p></li></ol>
            <p class="western" ></p>
            <ol start="16">
            <li>
            <p ><strong>Envision India Conference 2025</strong></p>
            
            <p >Date: 10<sup>th</sup> Jun 2025</p>
            <p ><a name="_GoBack"></a> <u>Place: Downtown San Francisco</u></p>
            <p ><u><a href="https://asiasociety.org/northern-california/events/envision-india-conference-2025">https://asiasociety.org/northern-california/events/envision-india-conference-2025</a></u></p></li></ol>
            <p ></p>
            <p class="western" ><strong><u>National Level</u></strong></p>
            <p class="western" ></p>
            <ol>
            <li>
            <p ><strong>11th WMO Scientific Conference on Weather Modification</strong></p>
            
            <p >Date: 3<sup>rd</sup>-7<sup>th</sup> November 2025</p>
            <p >Place: Pune, India</p>
            <p ><u><a href="https://wmo-11scwxmod.tropmet.res.in/">https://wmo-11scwxmod.tropmet.res.in/</a></u></p></li></ol>
            <p class="western" ></p>
            <ol start="2">
            <li>
            <p ><strong>International Conference on Climate Change</strong></p>
            
            <p >Date: 6<sup>th</sup> April 2025</p>
            <p >Place: Nagpur, India</p>
            <p ><u><a href="https://itrgroup.net/Conference/2167/ICCC/">https://itrgroup.net/Conference/2167/ICCC/</a></u></p></li></ol>
            <p class="western" ></p>
            <ol start="3">
            <li>
            <p ><strong>Eco Sustain Expo &amp; Conference</strong></p>
            
            <p >Date: 22<sup>nd</sup>-24<sup>th</sup> August 2025 </p>
            <p >Place: HITEX Exhibition Center, Hyderabad</p>
            <p ><u><a href="https://ecosustainexpo.in/">https://ecosustainexpo.in/</a></u></p></li></ol>
            <p class="western"></p>
            <ol start="4">
            <li>
            <p ><strong>India Process Expo &amp; Conference 2025</strong></p>
            
            <p >Date: 22<sup>nd</sup>-24<sup>th</sup> August 2025 </p>
            <p >Place: HITEX Exhibition Center, Hyderabad</p>
            <p ><u><a href="https://ipecexpo.in/ipec-2025/">https://ipecexpo.in/ipec-2025/</a></u></p></li></ol>
            <p class="western"></p>
            <ol start="5">
            <li>
            <p ><strong>Global Space Exploration Conference</strong></p>
            
            <p >Date: 7<sup>th</sup>-9<sup>th</sup> May 2025</p>
            <p >Place: New Delhi, India</p>
            <p ><u><a href="https://www.iirs.gov.in/">https://www.iirs.gov.in/</a></u></p></li></ol>
            <p class="western"></p>
            <ol start="6">
            <li>
            <p ><strong>NISAR Awareness Workshop</strong></p>
            
            <p >Date: 29<sup>th</sup> April 2025</p>
            <p >Place: Ahmedabad, India</p>
            <p ><u><a href="https://www.isro.gov.in/SAC_IN-SPACe_NSIL_NISAR_Awareness_Workshop.html">https://www.isro.gov.in/SAC_IN-SPACe_NSIL_NISAR_Awareness_Workshop.html</a></u></p></li></ol>
            <p class="western"></p>
            <ol start="7">
            <li>
            <p ><strong>YUVIKA Programme</strong></p>
            
            <p >Date: 19<sup>th</sup>-30<sup>th</sup> 2025</p>
            <p >Place: Dehradun, Thiruvananthapuram, Sriharikota, Bengaluru, Ahmedabad, Hyderabad, and Shillong</p>
            <p ><u><a href="https://jigyasa.iirs.gov.in/yuvika">https://jigyasa.iirs.gov.in/yuvika</a></u></p></li></ol>
            <p ></p></div>}
        />

    )
}
export default AnnouncementsPage;